import { render, staticRenderFns } from "./pendingApproval.vue?vue&type=template&id=794f595a&scoped=true&"
import script from "./pendingApproval.vue?vue&type=script&lang=js&"
export * from "./pendingApproval.vue?vue&type=script&lang=js&"
import style0 from "./pendingApproval.vue?vue&type=style&index=0&id=794f595a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794f595a",
  null
  
)

export default component.exports